var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkshop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1191 16.2441V18.9941L19.1191 20.2441M17.1191 1.24414V6.24414M23.3691 8.11914V6.24414C23.3691 5.5811 23.1057 4.94521 22.6369 4.47637C22.1681 4.00753 21.5322 3.74414 20.8691 3.74414H3.36914C2.7061 3.74414 2.07021 4.00753 1.60137 4.47637C1.13253 4.94521 0.869141 5.5811 0.869141 6.24414V23.7441C0.869141 24.4072 1.13253 25.0431 1.60137 25.5119C2.07021 25.9807 2.7061 26.2441 3.36914 26.2441H7.74414M0.869141 11.2441H7.11914M7.11914 1.24414V6.24414M24.6191 18.7441C24.6191 22.8863 21.2613 26.2441 17.1191 26.2441C12.977 26.2441 9.61914 22.8863 9.61914 18.7441C9.61914 14.602 12.977 11.2441 17.1191 11.2441C21.2613 11.2441 24.6191 14.602 24.6191 18.7441Z",
    stroke: "#2A7133",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshop);
export default __webpack_public_path__ + "static/media/workshop.4dc5e82a0843c49678159cbe098a1a75.svg";
export { ForwardRef as ReactComponent };